<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: '!font-proxima'
  }
})
</script>
